import { render, staticRenderFns } from "./CanteenIndicators.vue?vue&type=template&id=28ec7356&scoped=true&"
import script from "./CanteenIndicators.vue?vue&type=script&lang=js&"
export * from "./CanteenIndicators.vue?vue&type=script&lang=js&"
import style0 from "./CanteenIndicators.vue?vue&type=style&index=0&id=28ec7356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec7356",
  null
  
)

export default component.exports